import { Download } from "lucide-react";
import { fileUrl } from "@/lib/api";

export default function AppCard({ app, index }) {
  const img = fileUrl(app.image_path);

  return (
    <div
      className="group relative flex flex-col md:flex-row items-center gap-6 lg:gap-10 w-full rounded-3xl bg-[#121212] border border-white/10 p-6 lg:p-10 transition-all duration-300 ease-out focus-within:ring-4 focus-within:ring-[#E2FF31] focus-within:shadow-[0_0_60px_rgba(226,255,49,0.35)] hover:border-white/20"
      data-testid={`app-card-${index}`}
      style={{ animation: `fadeUp 0.5s ease-out ${index * 60}ms both` }}
    >
      {/* Logo left */}
      <div className="flex-shrink-0">
        <div className="w-36 h-36 lg:w-44 lg:h-44 rounded-2xl overflow-hidden bg-[#1a1a1a] flex items-center justify-center border border-white/5">
          {img ? (
            <img
              src={img}
              alt={app.name}
              className="w-full h-full object-contain"
              data-testid={`app-card-image-${index}`}
            />
          ) : (
            <div className="text-white/30 text-5xl font-black tracking-tighter">
              {app.name.slice(0, 2).toUpperCase()}
            </div>
          )}
        </div>
      </div>

      {/* Title & description middle */}
      <div className="flex flex-col gap-3 flex-1 min-w-0 text-center md:text-left">
        <h3
          className="font-heading text-3xl lg:text-5xl font-black text-white leading-none tracking-tight"
          data-testid={`app-card-name-${index}`}
        >
          {app.name}
        </h3>
        <p
          className="text-white/60 text-lg lg:text-2xl leading-snug"
          data-testid={`app-card-description-${index}`}
        >
          {app.description}
        </p>
      </div>

      {/* Download button right */}
      <div className="flex-shrink-0 w-full md:w-auto">
        <a
          href={app.download_url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`app-card-download-${index}`}
          className="flex items-center justify-center gap-3 w-full md:w-auto rounded-full bg-[#E2FF31] text-black px-10 py-5 lg:py-6 text-xl lg:text-2xl font-black tracking-wide transition-all duration-300 outline-none focus-visible:ring-4 focus-visible:ring-white/60 focus-visible:scale-[1.05] hover:bg-white hover:scale-[1.03]"
        >
          <Download className="w-6 h-6 lg:w-7 lg:h-7" strokeWidth={3} />
          <span>Download</span>
        </a>
      </div>
    </div>
  );
}
